import React, { useEffect } from 'react'
import { CartStyle } from './style'
import { CartToggleButton, Items, List, Title } from '../../style'
import { Icon } from 'components/Icon'
import { FormattedMessage } from 'react-intl'
import SliderItem from '../SliderItem'
import { stopPropagation } from 'utils/common'
import { setCartStateToDefault } from '../../thunk'
import { useDispatch } from 'react-redux'

const Cart = ({
	isOpen,
	isFooterVisible,
	quantityItem,
	listItem,
	exchangeList,
}) => {
	const dispatch = useDispatch()

	useEffect(() => {
		if (!isFooterVisible) {
			dispatch(setCartStateToDefault())
		}
	}, [isFooterVisible])

	return (
		<>
			<CartToggleButton isOpen={isOpen} isVisible={isFooterVisible}>
				<Icon component='arrowDown' />
			</CartToggleButton>
			<CartStyle isOpen={isOpen}>
				<Items>
					{!!exchangeList.length && (
						<>
							<Title>
								<FormattedMessage
									id='cart.expanded.newGoods.title'
									defaultMessage='Your Returns'
								/>
								({quantityItem})
							</Title>
							<List onClick={stopPropagation}>
								{exchangeList?.map((item) => {
									let { keyVariant, variants } = item
									let imageUrl = variants[keyVariant].imageUrl
									return (
										<div key={item?.orderItemId}>
											<SliderItem
												bgLittleDark
												isExchangeVariant
												item={item}
												imageUrl={imageUrl}
											/>
										</div>
									)
								})}
							</List>
						</>
					)}
					<Title>
						<FormattedMessage
							id='cart.expanded.returnedGoods.title'
							defaultMessage='YOUR RETURNS'
						/>
						({quantityItem})
					</Title>
					<List onClick={stopPropagation}>
						{listItem?.map((item) => (
							<div key={item.orderItemId}>
								<SliderItem
									item={item}
									imageUrl={item.imageUrl}
								/>
							</div>
						))}
					</List>
				</Items>
			</CartStyle>
		</>
	)
}
export default Cart
